import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the page scroll to the top whenever the pathname changes.
 * Also disables the browser's automatic scroll restoration so a hard
 * refresh never lands users mid-page or at the bottom.
 *
 * Must be rendered inside <BrowserRouter>.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
};
